module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "150px"
    }
  }, [_vm._v("About the Author")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-family": "Times New Roman"
    }
  }, [_vm._v("David was born in Brighton, UK, but mainly educated in Australia. He is Emeritus Professor of Economic Geology at the University of Western Australia, a Fellow of the Australian Academy of Science and a National Geoscience Champion, having received numerous medals and other awards for his teaching and research. He is also a consultant to the mining and exploration industry, mainly involved in conceptual targeting for discovery of new mineral deposits. He has adapted his holistic and multi-scale approach to forensic geological studies into the writing of cerebral thriller, mystery and mystical novels, involving a gold exploration background, with "), _c('em', [_vm._v("The Plagues’ Protocol")]), _vm._v(" the first of this genre and "), _c('em', [_vm._v("Destiny on Magic White Mountain")]), _vm._v(" the second.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0